import QueryManagementJobtitles from "graphql/queries/management/QueryManagementJobtitles";
import QueryManagementJobtitlesNoCount from "graphql/queries/management/QueryManagementJobtitlesNoCount";
import _ from "lodash";
import { setManagementByGuid } from 'services/redux/management/actions';
import { managementConstants } from 'services/redux/management/constants';
import store from 'services/redux/store';
import GraphqlBuilder from "utils/request/graphql/builder";

export default class FetchManagementJobtitle {
	
	static fetchAll( { callbackSuccess = null, callbackError = null, callbackStart = null, employeeCount = true, variables = {}, dispatchDataToStore = true } = {} ) {
		const query = employeeCount ? QueryManagementJobtitles : QueryManagementJobtitlesNoCount;

		new GraphqlBuilder()
			.addQuery( 'jobtitles', query, variables )
			.setResultPath( ['jobtitles', 'jobtitles'], [] )
			.setOnStart( callbackStart )
			.setOnError( callbackError )
			.setOnSuccess( result => {
				
				if( dispatchDataToStore ) {
					store.dispatch( setManagementByGuid( managementConstants.JOBTITLES, result ) )
				}
				
				if( callbackSuccess !== null && _.isFunction( callbackSuccess ) ) {
					callbackSuccess({
						jobtitles: result
					});
				}
			})
			.execute()
	}
}
